// @flow
import {
    CHECK_AUTH_TYPE,
    CHECK_AUTH_TYPE_FAILED,
    CHECK_AUTH_TYPE_SUCCESS,
    FORGET_PASSWORD,
    FORGET_PASSWORD_FAILED,
    FORGET_PASSWORD_SUCCESS,
    LOGIN_USER,
    LOGIN_USER_FAILED,
    LOGIN_USER_SUCCESS,
    LOGOUT_USER,
    REGISTER_LINKED_ACCOUNT,
    REGISTER_USER,
    REGISTER_USER_FAILED,
    REGISTER_USER_SUCCESS,
    FETCH_USER_PROFILE,
    FETCH_USER_PROFILE_SUCCESS,
    FETCH_USER_PROFILE_FAILED,
    INIT_AUTH,
    INIT_AUTH_SUCCESS,
    INIT_AUTH_FAILED,
} from './constants';

type AuthAction = { type: string, payload: {} | string };

export const registerLinkedAccount = (config: {}): AuthAction => ({
    type: REGISTER_LINKED_ACCOUNT,
    payload: config,
});

export const checkAuthType = (username: string): AuthAction => ({
    type: CHECK_AUTH_TYPE,
    payload: {username},
});

export const checkAuthTypeSuccess = (authType: {}): AuthAction => ({
    type: CHECK_AUTH_TYPE_SUCCESS,
    payload: authType,
});

export const checkAuthTypeFailed = (error: string): AuthAction => ({
    type: CHECK_AUTH_TYPE_FAILED,
    payload: error,
});

export const loginUser = (username: string, password: string, rememberMe: boolean): AuthAction => ({
    type: LOGIN_USER,
    payload: {username, password, rememberMe},
});

export const loginUserSuccess = (user: string): AuthAction => ({
    type: LOGIN_USER_SUCCESS,
    payload: user,
});

export const loginUserFailed = (error: string): AuthAction => ({
    type: LOGIN_USER_FAILED,
    payload: error,
});

export const registerUser = (fullname: string, email: string, password: string): AuthAction => ({
    type: REGISTER_USER,
    payload: {fullname, email, password},
});

export const registerUserSuccess = (user: {}): AuthAction => ({
    type: REGISTER_USER_SUCCESS,
    payload: user,
});

export const registerUserFailed = (error: string): AuthAction => ({
    type: REGISTER_USER_FAILED,
    payload: error,
});

export const logoutUser = (history: any): AuthAction => ({
    type: LOGOUT_USER,
    payload: {history},
});

export const forgetPassword = (username: string): AuthAction => ({
    type: FORGET_PASSWORD,
    payload: {username},
});

export const forgetPasswordSuccess = (passwordResetStatus: string): AuthAction => ({
    type: FORGET_PASSWORD_SUCCESS,
    payload: passwordResetStatus,
});

export const forgetPasswordFailed = (error: string): AuthAction => ({
    type: FORGET_PASSWORD_FAILED,
    payload: error,
});

export const fetchUserProfile = (): AuthAction => ({
    type: FETCH_USER_PROFILE,
    payload: {},
});

export const fetchUserProfileSuccess = (profile: {}): AuthAction => ({
    type: FETCH_USER_PROFILE_SUCCESS,
    payload: profile,
});

export const fetchUserProfileFailed = (error: string): AuthAction => ({
    type: FETCH_USER_PROFILE_FAILED,
    payload: error,
});

export const initAuth = (): AuthAction => ({
    type: INIT_AUTH,
    payload: {},
});

export const initAuthSuccess = (): AuthAction => ({
    type: INIT_AUTH_SUCCESS,
    payload: {},
});

export const initAuthFailed = (): AuthAction => ({
    type: INIT_AUTH_FAILED,
    payload: {},
});
